import { DeviceStateType } from './state'
import type { DeviceSample } from '../../DeviceSamples/models/deviceSample'

export interface DeviceGettersType {
  //getDeviceById: (state: DeviceStateType, id: string) => DeviceStateType['device']
  getDeviceMeasurementsById: (state: DeviceStateType, deviceId: string) => DeviceSample[]
  getDeviceLastMeasurementById: (state: DeviceStateType, deviceId: string) => DeviceSample | null
}

export const DeviceGetters = {
  // getDeviceById: (state: DeviceStateType) => (id: string) => {
  //   return state.devices.find(device => device.id === id)
  // },
  getDeviceMeasurementsById: (state: DeviceStateType) => (deviceId: string) => {
    return state.deviceMeasurements[deviceId] || []
  },
  getDeviceLastMeasurementById: (state: DeviceStateType) => (deviceId: string) => {
    return state.deviceLastMeasurement[deviceId] || null
  },
}
